// noinspection ExceptionCaughtLocallyJS

import {
  IonItem,
  IonLabel,
  IonInput,
  IonSelect,
  IonSelectOption,
  IonButton,
  IonCard,
  IonButtons,
  IonFooter,
  IonToolbar,
  useIonToast,
  IonLoading,
  IonSpinner,
} from "@ionic/react";

import { useEffect } from "react";
import React, {useMemo, useRef} from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import InputErrorMessage from "../../../components/InputErrorMessage";
import { setCreateArchiveStatus, setCreateDocumentStatus } from "../../../store/documentCreate";
import { createArchive } from "../../../store/documentCreate/actions/createArchiveBasic";
import { createDocument } from "../../../store/documentCreate/actions/createDocumentBasic";
import { selectCreateArchiveStatus } from "../../../store/documentCreate/selectors/selectCreateArchiveStatus";
import { selectCreateDocumentStatus } from "../../../store/documentCreate/selectors/selectCreateDocumentStatus";
import { selectDocumentCategory } from "../../../store/utils/selectors/selectDocumentCategory";
import { useParams } from "react-router-dom";
import addSigner from "../../../store/documentShow/actions/addSigner"
import { selectSignatureProviders } from "../../../store/signatureProviders/selectors/selectSignatureProviders";
import { getSignatureProviders } from "../../../store/signatureProviders/actions/getSignatureProviders";

type FormValues = {
  archive: any;
  archiveFilename: string;
  title: string;
  category: any;
  signatureProvider: any;
};

export const DocumentCreateForm: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [presentToast] = useIonToast();
  const createDocumentStatus = useSelector(selectCreateDocumentStatus);
  const createArchiveStatus = useSelector(selectCreateArchiveStatus);
  const fileInput = useRef<any>(null);
  const documentCategoryList = useSelector(selectDocumentCategory);
  const signatureProviders = useSelector(selectSignatureProviders);

  const { userId }: { userId: string } = useParams();

  const {
    register,
    control,
    setValue,
    formState: { errors },
    handleSubmit,
  } = useForm<FormValues>({
    defaultValues: {
      archive: null,
      archiveFilename: "",
      title: "",
      category: null,
      signatureProvider: null,
    },
  });

  useEffect(() => {
    console.log("Dispatching getSignatureProviders...");
    dispatch(getSignatureProviders());
    dispatch(setCreateArchiveStatus(""));
    dispatch(setCreateDocumentStatus(""));
  }, []);

  useEffect(() => {
    // No seleccionar automáticamente ninguna opción
  }, [signatureProviders, documentCategoryList]);



  const from ="detalle"

  const onSubmit = async (data: any) => {
    try {
      const { payload: documentCreated }: any = (await dispatch(createDocument(data))) || {};
      if (!documentCreated) {
        throw new Error("No se pudo crear acuerdo");
      }
      const addSignerData = {
        idUser :userId,
        idDoc: documentCreated.id
      }
      if(userId != undefined) {
        dispatch(addSigner(addSignerData));
      }
      userId != undefined ? history.replace(`/app/supervision/colaborador/acuerdos/${from}/${userId}/${documentCreated.id}`) :
      history.replace(`/app/rrhh/acuerdos/${documentCreated.id}`);
    } catch (error) {
      presentToast({
        message: "Ocurrió un problema creando acuerdo",
        duration: 8000,
        color: "danger",
      });
    }
  };

  const onFilechange = async (event: any) => {
    try {
      const [file] = event.target.files;
      if (!file) {
        return;
      }
      event.target.value = null;
      const { payload: archiveCreated }: any = await dispatch(createArchive(file));
      if (!archiveCreated) {
        throw new Error("No se ha subido el archivo");
      }
      setValue("archive", archiveCreated);
      setValue("archiveFilename", archiveCreated.filename);
    } catch (error:any) {
      const {message} = error
      console.log(message);
      setValue("archive", null);
      setValue("archiveFilename", "");
      presentToast({
        message: `Ocurrió un problema subiendo archivo ${message}`,
        duration: 8000,
        color: "danger",
      });
    }
  };

  const controllers = useMemo(() => {
    return [
      ({ field: { onChange, value } }: any) => (
        <IonInput
          value={value}
          placeholder="Ingrese el titulo"
          onIonChange={({ detail: { value } }) => onChange(value)}
        />
      ),
      ({ field: { onChange, value } }: any) => (
        <IonSelect
          value={value}
          okText="Aceptar"
          cancelText="Cancelar"
          placeholder="Seleccione tipo"
          onIonChange={({ detail: { value } }) => onChange(value)}
        >
          {documentCategoryList.map((type) => (
            <IonSelectOption value={type} key={`option-select-${type.id}`}>
              {type.name}
            </IonSelectOption>
          ))}
        </IonSelect>
      ),
      ({ field: { onChange, value } }: any) => (
        <IonSelect
          value={value}
          okText="Aceptar"
          cancelText="Cancelar"
          placeholder="Seleccione proveedor"
          onIonChange={({ detail: { value } }) => onChange(value)}
        >
          {signatureProviders.map((type) => (
            <IonSelectOption value={type} key={`option-select-${type.id}`}>
              {type.name}
            </IonSelectOption>
          ))}
        </IonSelect>
      )
    ];
  }, [documentCategoryList, signatureProviders]);


  return (
    <>
      <form noValidate onSubmit={handleSubmit(onSubmit)}>
        <IonCard style={{ maxWidth: 700 }}>
          <section className="ion-padding">
            <IonItem
              lines="inset"
              onClick={() => {
                fileInput?.current?.click();
              }}
              disabled={createArchiveStatus === "pending"}
            >
              <IonLabel position="stacked">Archivo</IonLabel>
              <Controller
                name="archiveFilename"
                control={control}
                render={({ field: { value } }: any) => (
                  <>
                    <input
                      ref={fileInput}
                      type="file"
                      accept="application/pdf"
                      onChange={onFilechange}
                      hidden
                    />
                    <IonInput
                      value={value}
                      placeholder="Seleccionar archivo"
                      {...register("archiveFilename", {
                        required: "Campo obligatorio.",
                      })}
                      readonly
                    />
                  </>
                )}
              />
              {createArchiveStatus === "pending" && <IonSpinner slot="end" />}
            </IonItem>
            <InputErrorMessage errorMessage={errors.archiveFilename?.message || ""} />

            <IonItem lines="inset">
              <IonLabel position="stacked">Titulo</IonLabel>
              <Controller
                name="title"
                control={control}
                render={controllers[0]}
              />
            </IonItem>
            <InputErrorMessage errorMessage={errors.title?.message || ""} />

            <IonItem lines="inset">
              <IonLabel position="stacked">Tipo de documento</IonLabel>
              <Controller
                name="category"
                control={control}
                render={controllers[1]}
              />
            </IonItem>

            <InputErrorMessage errorMessage={errors.category?.message || ""} />

            <IonItem lines="inset">
              <IonLabel position="stacked">Proveedor de firma</IonLabel>
              <Controller
                name="signatureProvider"
                control={control}
                render={controllers[2]}
              />
            </IonItem>

            <InputErrorMessage errorMessage={errors.signatureProvider?.message || ""} />
            <br />
          </section>

          <IonFooter>
            <IonToolbar color="light">
              <IonButtons slot="end">
                <IonButton fill="solid" type="submit">
                  Crear acuerdo
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonFooter>
        </IonCard>

        <IonLoading isOpen={createDocumentStatus === "pending"} message={"Creando acuerdo..."} />
      </form>
    </>
  );
};
